import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";

import MDBox from "mui_components/MDBox";
// import Breadcrumbs from "mui_components/Breadcrumbs";
// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarDesktopMenu,
  navbarMobileMenu,
} from "layout/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 PRO React context
import { setTransparentNavbar, setMiniSidenav, useDigitalPassController } from "context";
import MDTypography from "mui_components/MDTypography";

function getLoggedInRoleLabel(user) {
  if (!user) return "";
  const usertype = Number(user.usertype);
  if (usertype === 0 && user.subType === "terminal_port_police") return "Terminal Port Police";
  if (usertype === 0) return "Port Police";
  if (usertype === 1) return "Company Admin";
  if (usertype === 2) return "User";
  if (usertype === 3) return "System Admin";
  if (usertype === 4) return "Enforcement Officer Admin";
  if (usertype === 5) return "Enforcement Officer User";
  if (usertype === 6) return "PPC Admin";
  return "";
}

function DashboardNavbar({ absolute, light = true, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useDigitalPassController();
  //const [company] = useState(JSON.parse(localStorage.getItem("company")));
  //const [user] = useState(JSON.parse(localStorage.getItem("user")));

  const { miniSidenav, transparentNavbar, fixedNavbar, userDetails } = controller;
  const roleLabel = getLoggedInRoleLabel(userDetails);

  const location = useLocation();
  const { pathname } = location;

  // const route = useLocation().pathname.split("/").slice(1);
  useEffect(() => {
    // Setting the navbar type

    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text } }) => ({
    color: () => {
      let colorValue = dark.main;

      if (transparentNavbar && !light) {
        colorValue = text.main;
      }

      return colorValue;
    },
  });

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <Toolbar sx={(theme) => ({ ...navbarContainer(theme), position: "relative" })}>
        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          {/* <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} /> */}
          <IconButton sx={navbarDesktopMenu} onClick={handleMiniSidenav} size="small" disableRipple>
            <Icon fontSize="medium" sx={iconsStyle}>
              {miniSidenav ? "menu_open" : "menu"}
            </Icon>
          </IconButton>
          <MDTypography
            variant="body2"
            color="info"
            sx={{
              display: "flex",
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            {pathname.split("/").length === 3
              ? (pathname.split("/")[2].length < 13 ? pathname.split("/")[2].toUpperCase() : "") +
                " " +
                pathname.split("/")[1].toUpperCase() +
                " " +
                (userDetails?.usertype === 2 && pathname.split("/")[2] === "new"
                  ? "REQUEST"
                  : pathname.split("/")[2].length < 13
                  ? ""
                  : "DETAILS")
              : pathname.split("/").length === 2
              ? pathname.split("/")[1].toUpperCase()
              : ""}
          </MDTypography>
        </MDBox>
        {roleLabel && !isMini ? (
          <Box
            component="span"
            sx={({ palette }) => ({
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              px: 1.75,
              py: 0.75,
              borderRadius: "999px",
              color: palette.dark.main,
              backgroundColor: "rgba(255, 255, 255, 0.92)",
              border: "1px solid rgba(26, 115, 232, 0.16)",
              boxShadow: "0 1px 1px rgba(52, 71, 103, 0.04), 0 10px 24px rgba(26, 115, 232, 0.10)",
              backdropFilter: "blur(12px)",
              fontSize: "0.68rem",
              fontWeight: 700,
              letterSpacing: "0.16em",
              lineHeight: 1,
              textTransform: "uppercase",
              whiteSpace: "nowrap",
              pointerEvents: "none",
            })}
          >
            <Box
              component="span"
              sx={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                flexShrink: 0,
                background: "linear-gradient(180deg, #49a3f1 0%, #1A73E8 100%)",
                boxShadow: "0 0 0 3px rgba(26, 115, 232, 0.14)",
              }}
            />
            {roleLabel}
          </Box>
        ) : null}
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <MDBox color={light ? "white" : "inherit"}>
              <MDTypography
                variant="button"
                sx={{
                  ...navbarIconButton,
                  display: "flex",
                  alignItems: "center",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                }}
              >
                <Icon sx={{ ...iconsStyle, marginRight: 1 }}>account_circle</Icon>
                Welcome{" "}
                {/* {userDetails &&
                (userDetails.usertype === 0 || userDetails.usertype === 2)
                  ? userDetails.email
                  : companyDetails.name} */}
                {userDetails?.name || userDetails?.email || ""}
              </MDTypography>

              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
